export enum TipoCotistaEnum {
  AGENTE_FINANCEIRO = 'AGENTE_FINANCEIRO', PESSOA_JURIDICA = 'PESSOA_JURIDICA'
}
